import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { ReactComponent as SuccessIcon } from '@Assets/icons/success.svg';
import { APY_RATE, EFFECTIVE_APY_DATE } from '@Types/consts';

export const ValuesProposalPasswordless = () => {
  const { t } = useTranslation();

  return (
    <div className='flex h-full flex-col justify-between sm:pb-[20px]'>
      <div className='mb-[24px]'>
        <img className='w-[62px] mb-[24px]' src={logoUrl} alt='Lili logo' />
        <Heading.H4 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary mb-[24px]'>
          {t('pages.homePasswordless.valueProposal.title')}
        </Heading.H4>
        <Heading.H9 fontWeight={FontWeight.SEMIBOLD} className='mb-[20px]'>
          {t('pages.homePasswordless.valueProposal.listTitle')}
        </Heading.H9>
        <div className='flex flex-col gap-[16px]'>
          <div className='flex flex-row gap-[6px] items-center'>
            <SuccessIcon />
            <Heading.H10 fontWeight={FontWeight.MEDIUM}>
              {t('pages.homePasswordless.valueProposal.noHiddenFees')}
            </Heading.H10>
          </div>
          <div className='flex flex-row gap-[6px] items-center'>
            <SuccessIcon />
            <Heading.H10 fontWeight={FontWeight.MEDIUM}>
              {t('pages.homePasswordless.valueProposal.expressACH')}
            </Heading.H10>
          </div>
          <div className='flex flex-row gap-[6px] items-center'>
            <SuccessIcon />
            <Heading.H10 fontWeight={FontWeight.MEDIUM}>
              {t('pages.homePasswordless.valueProposal.annualPercentageYield', {
                apyRate: APY_RATE,
              })}
              <sup>1</sup>
            </Heading.H10>
          </div>
          <div className='flex flex-row gap-[6px] items-center'>
            <SuccessIcon />
            <Heading.H10 fontWeight={FontWeight.MEDIUM}>
              {t('pages.homePasswordless.valueProposal.builtInPayments')}
            </Heading.H10>
          </div>
          <div className='flex flex-row gap-[6px] items-center'>
            <SuccessIcon />
            <Heading.H10 fontWeight={FontWeight.MEDIUM}>
              {t('pages.homePasswordless.valueProposal.dnbScores')}
              <sup>2</sup>
            </Heading.H10>
          </div>
        </div>
      </div>

      <div className='flex flex-col'>
        <ol className='list-decimal text-[10px] text-text-main-secondary pl-[8px]' type='1'>
          <li>
            <Text.H14 className='text-text-main-secondary'>
              {t('pages.homePasswordless.valueProposal.APYLegal', {
                apyEffectiveDate: EFFECTIVE_APY_DATE,
              })}
            </Text.H14>
          </li>
          <li>
            <Text.H14 className='text-text-main-secondary'>
              {t('pages.homePasswordless.valueProposal.DNBScoresLegal')}
            </Text.H14>
          </li>
        </ol>
        <div className='flex flex-col gap-[4px] tab-landscape:bg-transparent mt-[8px]'>
          <Text.H14 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-secondary'>
            {t('pages.homePasswordless.valueProposal.USAPatriotNotice')}
          </Text.H14>
          <Text.H14 className='text-text-main-secondary'>
            {t('pages.homePasswordless.valueProposal.USAPatriotNoticeContent')}
          </Text.H14>
          <Text.H14 className='text-text-main-secondary' id='value-proposal-disclaimer'>
            {t('pages.homePasswordless.valueProposal.disclaimer')}
          </Text.H14>
        </div>
      </div>
    </div>
  );
};
